import React from "react";
import ReactDOM from "react-dom";

import { IntlProviderWrapper } from "./intlProviderWrapper";

ReactDOM.render(<IntlProviderWrapper />, document.getElementById("root"));
